import React from 'react';

interface StarRatingProps {
  value: number;
  onChange?: (rating: number) => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: 'w-5 h-5',
  md: 'w-8 h-8',
  lg: 'w-11 h-11',
};

const touchTargetMap = {
  sm: 'min-w-[28px] min-h-[28px]',
  md: 'min-w-[44px] min-h-[44px]',
  lg: 'min-w-[44px] min-h-[44px]',
};

export const StarRating: React.FC<StarRatingProps> = ({
  value,
  onChange,
  disabled = false,
  size = 'md',
}) => {
  const starSize = sizeMap[size];
  const touchTarget = touchTargetMap[size];

  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={disabled || !onChange}
          onClick={() => onChange?.(star)}
          className={`${touchTarget} flex items-center justify-center transition-transform ${
            disabled ? 'cursor-default' : 'cursor-pointer active:scale-110'
          }`}
          aria-label={`${star} star${star > 1 ? 's' : ''}`}
        >
          <svg
            className={`${starSize} transition-colors`}
            viewBox="0 0 24 24"
            fill={star <= value ? '#f59e0b' : 'none'}
            stroke={star <= value ? '#f59e0b' : '#d1d5db'}
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
            />
          </svg>
        </button>
      ))}
    </div>
  );
};
